import { useState } from 'react';
import { Tabs, Tab, Box, Badge } from '@mui/material';
import TrainingList from './TrainingList';

function CapacitacionTabs({ counts = {}, onUpdate }) {
  const [value, setValue] = useState(0);

  const handleChange = (_event, newValue) => {
    setValue(newValue);
  };

  const subtypes = [
    'Persona física',
    'Institución pública', 
    'Agente económico'
  ];

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="capacitacion subtabs"
        sx={{ mb: 2 }}
      >
        {subtypes.map((subtype, index) => (
          <Tab 
            key={index} 
            label={
              <Badge badgeContent={counts[subtype] || 0} color="error">
                {subtype}
              </Badge>
            } 
          />
        ))}
      </Tabs>

      {subtypes.map((subtype, index) => (
        value === index && (
          <Box key={index}>
            <TrainingList 
              type="Capacitación" 
              subtype={subtype}
              title={`Capacitaciones - ${subtype}`}
              onUpdate={onUpdate}
            />
          </Box>
        )
      ))}
    </Box>
  );
}

export default CapacitacionTabs;